import Type from '@/component/Primitive/Type'
import moment from 'moment/moment'
import { number, string } from 'prop-types'
import React from 'react'

const DateLabel = ({ date }) => {
  return (
    <Type as="h3" size={['heading5', 'heading4']} weight="bold">
      {moment(date).format('dddd Do MMMM')}
    </Type>
  )
}

export default DateLabel

DateLabel.propTypes = {
  date: string
}
